import { render, staticRenderFns } from "./staff_payslips.vue?vue&type=template&id=8a73336e&scoped=true&"
import script from "./staff_payslips.vue?vue&type=script&lang=js&"
export * from "./staff_payslips.vue?vue&type=script&lang=js&"
import style0 from "./staff_payslips.vue?vue&type=style&index=0&id=8a73336e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a73336e",
  null
  
)

export default component.exports